<template>
    <div>
        <a-modal
            title="Encontrar codigo do município e estado"
            :visible="showModalFindCode"
            okText="Localizar"
            cancelText="Cancelar"
            @cancel="showModalFindCode = false"
        >
            <div class="flex">
                <cep class="w-11/12" @fetched="(val) => getIBGECodes(val)"/>
                <a-button class="w-1/12 mt-6 h-12 " type="link"><feather-icon icon="SearchIcon" svgClasses="stroke-curren" /></a-button>
            </div>

            <template slot="footer">
                <a-button key="submit" type="primary" @click="() => showModalFindCode = false">
                    Fechar
                </a-button>
            </template>
        </a-modal>
        <vx-card no-shadow>
            <a-alert
                class="mb-base"
                v-if="company.fiscal.allowNFCe"
                message="Fique atento!"
                description="Pode ser necessário o auxílio de um contador para preencher os campos."
                type="info"
                show-icon />

            <div class="w-full mb-4">
                <vs-checkbox color="danger" v-model="company.fiscal.allowNFCe">Gerar nota fiscal do consumidor (NFCe)</vs-checkbox>
            </div>

            <div v-show="company.fiscal.allowNFCe" class="mt-base">

                <vs-divider border-style="dashed" class="mb-base mt-base" > NFCe </vs-divider>
                
                <div class="w-full">
                    <span>Nº Sequencial</span>
                    <div class="flex">
                        <a-input-number class="sm:w-2/12 md:w-2/12 lg:w-2/12 xl:w-2/12" v-validate="{ required: true, numeric : true,  }" name="Sequencial" ref="Sequencial" v-model="company.fiscal.numeroSequencia" :min="0" size="large" />
                    </div>
                    <span class="text-danger text-sm" v-show="errors.has('Sequencial')">{{ errors.first('Sequencial') }}</span>
                </div>

                <vs-divider border-style="dashed" class="mb-base mt-base" > TRIBUTÁRIO </vs-divider>

                <div class="w-full mb-4">
                    <span>Fato Gerador</span>
                    <vs-input type="text" v-validate="{required : true, alpha_num : true}" name="Fato Gerador" ref="Fato Gerador" class="sm:w-2/12 md:w-2/12 lg:w-2/12 xl:w-2/12" v-model="company.fiscal.codIbgeFatoGerador"></vs-input>
                    <span class="text-danger text-sm" v-show="errors.has('Fato Gerador')">{{ errors.first('Fato Gerador') }}</span>
                </div>
                
                <div class="w-full mb-4">
                    <span>Código UF</span>
                    <div class="flex">
                        <vs-input type="text" v-validate="{required : true, alpha_num : true}" name="Código UF" ref="Código UF" class="sm:w-2/12 md:w-2/12 lg:w-2/12 xl:w-2/12" icon-pack="feather" icon="icon-map-pin" icon-no-border v-model="company.fiscal.endereco.cUf"></vs-input>
                    </div>
                    <span class="text-danger text-sm" v-show="errors.has('Código UF')">{{ errors.first('Código UF') }}</span>
                </div>

                <div class="w-full mb-4">
                    <span>Código do Município</span>
                    <div class="flex">
                        <vs-input type="text" v-validate="{required : true, alpha_num : true}" name="Código Município" ref="Código Município" class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-3/12" icon-pack="feather" icon="icon-map-pin" icon-no-border v-model="company.fiscal.endereco.codMunicipio"></vs-input>
                        <a-button type="dashed" class="ml-3 h-12" @click="() => showModalFindCode = true"><feather-icon icon="SearchIcon" svgClasses="stroke-curren" /></a-button>
                    </div>
                    <span class="text-danger text-sm" v-show="errors.has('Código Município')">{{ errors.first('Código Município') }}</span>
                </div>

                <div class="w-full mb-4">
                    <span>Código de Segurança do Contribuinte (CSC)</span>
                    <vs-input type="text" v-validate="{required : true, alpha_num : true, min: 36, max:36}" name="CSC" ref="CSC" class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-2/3 sm:w-full md:w-1/2 lg:w-1/2 xl:w-2/3 " icon-pack="feather" icon="icon-unlock" icon-no-border v-model="company.fiscal.CSC"></vs-input>
                    <span class="text-danger text-sm" v-show="errors.has('CSC')">{{ errors.first('CSC') }}</span>
                </div>

                <div class="w-full mb-4">
                    <span>Código de Regime Tributário (CRT)</span>
                    <v-select :clearable="false" :options="regimeTributario" :value="selectCRT(company.fiscal.codRegimeTributario)" @input="(val) => changeCRT(val)" class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-2/3 " /> 
                </div>

                <vs-divider border-style="dashed" class="mb-base mt-base" > CERTIFICADO </vs-divider>

                <div class="w-full mb-2">
                    <a-upload class="w-full" :file="file" :remove="handleRemove" :before-upload="beforeUpload" :showUploadList="false">
                        <a-button> <a-icon type="upload" /> {{ file ? `Alterar certificado ${file.name ? '(' + file.name + ')' : ''}` : 'Selecionar certificado' }} </a-button>
                    </a-upload>
                </div>

                <a-button class="text-danger mb-4" v-if="company.fiscal.certificateURL" @click="() => company.fiscal.certificateURL = ''"> <a-icon type="delete" /> Remover Certificado </a-button>

                <div class="w-full mb-2">
                    <span>Senha do certificado</span>
                    <vs-input type="password" v-validate="{required : true}" name="Senha" ref="Senha" class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-2/3 sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/3 " icon-pack="feather" icon="icon-unlock" icon-no-border v-model="company.    fiscal.certPassword"></vs-input>
                    <span class="text-danger text-sm" v-show="errors.has('Senha')">{{ errors.first('Senha') }}</span>
                </div>

                <div class="flex flex-wrap items-center">
                    <vs-button class="mt-2" @click="save()">Salvar Alterações</vs-button>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import vSelect from 'vue-select'
    import Cep from '@/components/shared/Cep'
    import States from '@/components/shared/States.js'

    export default {
        components : {
            Cep,
            vSelect
        },

        created () {
            this.getFiscalData()
        },

        data () {
            return {
                ref : firebase.firestore(),
                file : 'teste',
                showModalFindCode : false,
                company : {
                    fiscal : {
                        codRegimeTributario : '1',
                        endereco : {
                            cUf : '',
                            codMunicipio : ''
                        },
                        numeroSequencia : 0,
                        allowNFCe : true,
                        certificateURL: ''
                    }
                },
                regimeTributario : [
                    { label: '[1] - Simples Nacional', code: '1' },
                    { label: '[2] - Simples Nacional com excesso de sublimite de receita    ', code: '2' },
                    { label: '[3] - Regime Normal (Que não se enquadrar em 1 e 2)', code: '3' }
                ]
            }
        },

        methods : {
            async getFiscalData () {
                let companyId = this.$store.getters.getCompanyID

                try {
                    this.$vs.loading()
                    let companyData = await this.ref.collection('company').doc(companyId).get();
                    this.company = companyData.data();
                } catch(err) {
                    this.$vs.error(err.message)
                } finally {
                    this.$vs.loading.close()
                }
            },

            async save () {
                try {
                    let companyId = this.$store.getters.getCompanyID

                    if(!await this.$validator.validateAll()) return

                    let certificateURL = await this.uploadCertificate()
                    if(!certificateURL) return
                    
                    this.$set(this.company.fiscal, 'certificateURL', certificateURL)

                    this.$vs.loading()
                    await this.ref.collection('company').doc(companyId).update(this.company)

                    this.$store.dispatch('updateCompanyFiscal', this.company.fiscal)
                    this.$store.dispatch('updateCompanyAddress', this.company.fiscal.endereco)

                    this.$message.success('Informações ficais alteradas com sucesso!', 8)
                } catch (err) {
                    this.$vs.dialog({
                        type: 'alert',
                        title: 'Erro',
                        text : `Erro ao tentar salvar informações fiscais: ${err.message}`,
                        acceptText : 'Fechar'
                    })
                } finally {
                    this.$vs.loading.close()
                }
            },

            async uploadCertificate () {
                try {
                    let companyId = this.$store.getters.getCompanyID
                    let storageRef  = firebase.app().storage('gs://pedido-rapido-dfe').ref()
                    let certificate = storageRef.child(`${companyId}/certificate/${this.file.name}`)
                   
                    return new Promise(async resolve => {
                        let upload = await certificate.put(this.file)
                        resolve(await certificate.getDownloadURL() || false)
                    })
                } catch (err) {
                    this.$vs.dialog({
                        type: 'alert',
                        title: 'Erro',
                        text : `Erro ao tentar salvar informações fiscais: ${err.message}`,
                        acceptText : 'Fechar'
                    })
                } 
            },

            changeCRT (val) {
                this.$set(this.company.fiscal, 'codRegimeTributario', val.code)
            },

            selectCRT (val) {
                let selected = ''
                this.regimeTributario.forEach((k) => {
                    if(k.code == val) selected = k
                })

                return selected
            },

            handleRemove (file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
            },

            beforeUpload (file) {
                this.file = file
                return false;
            },

            getIBGECodes (val) {
                this.$message.success('Código UF e do município encontrados!', 5)
                this.$set(this.company.fiscal.endereco, 'cUf', States.getCUFByCode(val.data.uf))
                this.$set(this.company.fiscal.endereco, 'codMunicipio', val.data.ibge)
                
                setTimeout(() => {
                    this.$validator.validateAll()
                }, 100)
            }
        }
    }
</script>